import { Component, OnInit } from '@angular/core';
import { cloneData } from 'src/app/helper/class/utilityHelper';
import { pageInfo } from 'src/app/helper/interface/menu-interface';
import { formBuilder } from 'src/app/helper/interface/response';
import { ModalService } from 'src/app/shared/service/modal.service';
import { ADD_APPOINTMENT } from '../../helper/appointment-form';
import { Router } from '@angular/router';
import { UrlServices } from 'src/app/helper/class/url-services';
import { Subject } from 'rxjs';
import { AppointmentApiService } from '../../service/appointment-api.service';
import { AlertService } from 'src/app/helper/service/alert.service';
import { RESPONSE_CODE } from 'src/app/helper/class/app-constant';
import { AddAppointmentComponent } from '../add-appointment/add-appointment.component';

const APPOINTMENT_MONITOR_REFRESH_KEY = 'appointment-monitor-refresh';

@Component({
  selector: 'app-appointment-info',
  templateUrl: './appointment-info.component.html',
  styleUrl: './appointment-info.component.scss'
})
export class AppointmentInfoComponent implements OnInit {
  pageInfo: pageInfo = {} as pageInfo;
  formData: formBuilder[] = []
  appointmentData: any;
  urlService = UrlServices.PAGE_URL;
  isModal: boolean = false
  public onClose: Subject<any> = new Subject();

  constructor(
    private modalService: ModalService,
    private router: Router,
    private appointApi: AppointmentApiService,
    private alertService: AlertService,
  ) { }


  ngOnInit(): void { }

  setInput(data) {
    this.isModal = true;
    this.appointmentData = data;
    console.log('appointmentdaya', this.appointmentData.patient_fk_id)
    const exField: formBuilder[] = [{ colName: 'rescheduledStatusName', title: 'Rescheduled' }, { colName: 'statusName', title: 'status' }, { colName: 'created_byName', title: 'Created By' }, { colName: 'created_at', title: 'Created On', type: 'DATETIME' }, { colName: 'updated_at', title: 'last Update', type: 'DATETIME' }]
    this.formData = [...cloneData(ADD_APPOINTMENT), ...exField].map((a: formBuilder) => {
      if (a.colName == 'doctor_fk_id') {
        a.selectKeyName = 'doctorName'
      } else if (a.colName == 'patient_fk_id') {
        a.selectKeyName = 'patientName'
      } else if (a.colName == 'appointment_on') {
        a.type = 'DATETIME'
      }
      return a
    });
    this.pageInfo = {
      title: 'Appointment Info'
    }
  }

  routePatient() {
    this.close()
    this.router.navigate([this.urlService.PATIENT.PATIENT_TREATMENT.URL], { queryParams: { id: this.appointmentData.patient_fk_id } })
  }

  get appointmentOn() {
    return this.resolveAppointmentDateTime(this.appointmentData);
  }

  get appointmentDay() {
    const appointmentOn = this.appointmentOn;
    return appointmentOn ? appointmentOn.toLocaleDateString('en-US', { weekday: 'long' }) : '-';
  }

  get appointmentDate() {
    const appointmentOn = this.appointmentOn;
    return appointmentOn ? appointmentOn.toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' }) : '-';
  }

  get appointmentTime() {
    const appointmentOn = this.appointmentOn;
    return appointmentOn ? appointmentOn.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit' }) : '-';
  }

  get appointmentStatus() {
    return this.appointmentData?.statusName || this.appointmentData?.status_name || this.appointmentData?.status || 'Pending';
  }

  get isTodayAppointment() {
    const appointmentOn = this.appointmentOn;
    if (!appointmentOn) {
      return false;
    }
    const today = new Date();
    return appointmentOn.toDateString() === today.toDateString();
  }

  get isPreviousAppointment() {
    const appointmentOn = this.appointmentOn;
    if (!appointmentOn) {
      return false;
    }
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const appointmentDate = new Date(appointmentOn);
    appointmentDate.setHours(0, 0, 0, 0);
    return appointmentDate < today;
  }

  get showRescheduleButton() {
    return !this.isPreviousAppointment;
  }

  get showDeleteButton() {
    return this.isTodayAppointment;
  }

  get patientName() {
    return this.appointmentData?.patientName || this.appointmentData?.patient_name || '-';
  }

  get patientId() {
    return this.appointmentData?.patient_id || this.appointmentData?.patientId || this.appointmentData?.patient_fk_id || '-';
  }

  get doctorName() {
    return this.appointmentData?.doctorName || this.appointmentData?.doctor_name || this.appointmentData?.fname || '-';
  }

  get treatmentName() {
    return this.appointmentData?.treatmentName || this.appointmentData?.treatment_name || this.appointmentData?.treatment || '-';
  }

  get phoneNumber() {
    return this.appointmentData?.mobile_no || this.appointmentData?.phone || this.appointmentData?.phone_no || this.appointmentData?.mobile || '-';
  }

  get notes() {
    return this.appointmentData?.notes || this.appointmentData?.note || this.appointmentData?.description || 'No notes added.';
  }

  resolveAppointmentDateTime(data: any): Date | null {
    if (!data) {
      return null;
    }
    const appointmentOn = data?.appointment_on || data?.appointment_date || data?.appointmentDate;
    if (!appointmentOn) {
      return null;
    }
    const appointmentTime = data?.appointment_time || data?.appointmentTime || '';
    const date = new Date(`${appointmentOn} ${appointmentTime}`.trim());
    return isNaN(date.getTime()) ? null : date;
  }

  rescheduleAppointment() {
    const data = { ...this.appointmentData, type: 'RESCHEDULE' };
    this.modalService.close();
    setTimeout(() => {
      this.modalService.openModal(AddAppointmentComponent, data, 'modal-lg').then((res) => {
        if (res) {
          this.onClose.next(res);
        }
      });
    }, 300);
  }

  deleteAppointment() {
    if (!this.appointmentData?.id) {
      this.alertService.showToast('Unable to delete appointment', 'error');
      return;
    }

    this.appointApi.deleteAppointment(this.appointmentData.id).then((res: any) => {
      if (res.statusCode == RESPONSE_CODE.SUCCESS) {
        this.notifyAppointmentMonitorRefresh();
        this.alertService.showToast('Appointment deleted successfully', 'success');
        this.onClose.next(true);
        this.close();
        window.location.reload();
      }
    }).catch(() => this.alertService.showToast('Unable to delete appointment', 'error'));
  }

  notifyAppointmentMonitorRefresh() {
    localStorage.setItem(APPOINTMENT_MONITOR_REFRESH_KEY, Date.now().toString());
  }

  close() {
    if (this.isModal) {
      this.modalService.close()
    }
  }
}
